export class StatusValue {
    value

    constructor(value) {
        this.value = value;
    }

    static create(value) {
        return new StatusValue(value);
    }

    is(value) {
        return this.value === value;
    }

    isNot(value) {
        return this.value !== value;
    }

    isAfter(value) {
        return this.value > value;
    }

    isOrAfter(value) {
        return this.value >= value;
    }

    isBefore(value) {
        return this.value < value;
    }

    isOrBefore(value) {
        return this.value <= value;
    }
}
